import type { FC } from 'react';
import InfoTag from 'components/InfoTag';
import { LongShortEnum, SymbolTypeEnum, TransferAssetFormData, TransferPropertyInfoItem } from 'modules/Transfer/type';
import { ReactComponent as IconDelete } from 'static/images/icons/delete.svg';
import { ReactComponent as IconEdit } from 'static/images/icons/edit.svg';
import MarketTag from '../MarketTag';
import style from './style.scss';

const longShortMap: Record<LongShortEnum, string> = {
    [LongShortEnum.LONG]: __('LongShort:Long'),
    [LongShortEnum.SHORT]: __('LongShort:Short')
};

export type SymbolPreviewItem = TransferAssetFormData & Pick<TransferPropertyInfoItem, 'expiry' | 'putCall' | 'strike'>;

interface SymbolPreviewListProps {
    data?: SymbolPreviewItem[];
    onEdit?: (symbol: string) => void;
    onDelete?: (symbol: string) => void;
    className?: string;
}

const SymbolPreviewList: FC<SymbolPreviewListProps> = ({ data, onEdit, onDelete, className }) => {
    if (!data?.length) {
        return null;
    }

    const renderOptionInfo = (item: SymbolPreviewItem) => {
        /* 只有期权展示 */
        if (item.secType === 'OPTION') {
            return (
                <>
                    {item.expiry && <span className="ml-1">{item.expiry}</span>}
                    {item.strike && <span className="ml-1">{item.strike}</span>}
                    {item.putCall && <span className="ml-1">{item.putCall}</span>}
                </>
            );
        }

        return null;
    };

    return (
        <div className={className}>
            {data.map(item => {
                const optionInfo = renderOptionInfo(item);

                return (
                    <div key={item.symbol} className={style.symbolItem}>
                        <div className={style.symbolHeader}>
                            <div className={style.symbolTitle}>
                                <div className={style.symbolName}>
                                    <span>{item.symbol_name}</span>
                                    {optionInfo}
                                </div>
                                <div>
                                    {typeof onDelete === 'function' && (
                                        <IconDelete className={style.icon} onClick={() => onDelete(item.symbol)} />
                                    )}
                                    {typeof onEdit === 'function' && (
                                        <IconEdit className={style.icon} onClick={() => onEdit(item.symbol)} />
                                    )}
                                </div>
                            </div>
                            <div className={style.symbolMarket}>
                                <MarketTag market="US" />
                                <div className={style.symbolCode}>
                                    <span>{item.symbol}</span>
                                    {optionInfo}
                                </div>
                            </div>
                        </div>
                        <div>
                            <InfoTag label={__('Quantity')} content={item.quantity} />
                            {item.type !== SymbolTypeEnum.MUTUAL_FUND && (
                                <InfoTag label={__('Long / Short')} content={longShortMap[item.long_short]} />
                            )}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default SymbolPreviewList;
